/**
    @function date
    @summary Parses numbers and strings to valid Javascript Date objects.
    @description Returns a javascript Date object for a given a Number (representing either a 4-digit year or milliseconds since epoch), a String representing a Quarter (ie. "Q2 1987", mapping to the last day in that quarter), or a String that is in [valid dateString format](http://dygraphs.com/date-formats.html). Besides the 4-digit year parsing, this function is useful when needing to parse negative (BC) years, which the vanilla Date object cannot parse.
    @param {Number|String} *date*
*/
export default function (d) {
  // returns if falsey or already Date object
  if ([false, undefined, NaN].includes(d) || d.constructor === Date) return d;
  // detects if milliseconds
  else if (d.constructor === Number && "".concat(d).length > 5 && d % 1 === 0) return new Date(d);
  var s = "".concat(d);

  // tests for MM/DD/YYYY and MM-DD-YYYY format
  var dayFormat = new RegExp(/^\d{1,2}[./-]\d{1,2}[./-](-*\d{1,4})$/g).exec(s);
  if (dayFormat) {
    var year = dayFormat[1];
    if (year.indexOf("-") === 0) s = s.replace(year, year.substring(1));
    var date = new Date(s);
    date.setFullYear(year);
    return date;
  }

  // tests for full Date object string format
  var strFormat = new RegExp(/^[A-z]{1,3} [A-z]{1,3} \d{1,2} (-*\d{1,4}) \d{1,2}:\d{1,2}:\d{1,2} [A-z]{1,3}-*\d{1,4} \([A-z]{1,3}\)/g).exec(s);
  if (strFormat) {
    var _year = strFormat[1];
    if (_year.indexOf("-") === 0) s = s.replace(_year, _year.substring(1));
    var _date = new Date(s);
    _date.setFullYear(_year);
    return _date;
  }

  // tests for quarterly formats (ie. "QX YYYY")
  var quarterPrefix = new RegExp(/^([qQ]{1}[1-4]{1}|[1-4]{1}[qQ]{1})[\s|-]{0,1}(-*\d{1,4})$/g).exec(s);
  var quarterSuffix = new RegExp(/^(-*\d{1,4})[\s|-]{0,1}([qQ]{1}[1-4]{1}|[1-4]{1}[qQ]{1})$/g).exec(s);
  if (quarterPrefix || quarterSuffix) {
    var quarter = +(quarterPrefix ? quarterPrefix[1] : quarterSuffix[2]).toLowerCase().replace("q", "");
    var _year2 = +(quarterPrefix ? quarterPrefix[2] : quarterSuffix[1]);
    var _date2 = new Date(_year2, quarter * 3 - 3, 1);
    _date2.setFullYear(_year2);
    return _date2;
  }

  // detects if only passing a year value
  if (!s.includes("/") && !s.includes(" ") && (!s.includes("-") || !s.indexOf("-"))) {
    var _date3 = new Date(+s, 0, 1);
    _date3.setFullYear(d);
    return _date3;
  }

  // falls back to Date object
  return new Date(s);
}